import styled, { css } from 'styled-components';

export const StoreRow = styled.div`
  ${({ theme: { palette } }) => css`
    border-bottom: 1px solid ${palette.baseColors.alto};
    display: grid;
    grid-template-columns: 6fr 2fr;
  `}
`;

export const Selection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: ${({ theme: { spacing } }) => `${spacing.s2} 0`};
`;
